// Add only Portal 3 specific overrides here.
const tab3Module = {
  pages: {},
  components: {},
};

export default tab3Module;
